import { Button, Card, Chip, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import React from 'react';
import { NavLink } from 'react-router-dom';
import APICaller, { MethodType } from '../common/APICaller';
import { useNavigate } from 'react-router-dom';

interface AssessmentCardProps {
  title: string;
  id: number;
  isComplete: number; // 1 or 0
  isStarted: number; // 1 or 0
  isOptional?: boolean | number;
  jobId: string | undefined
}

const AssessmentCard: React.FC<AssessmentCardProps> = ({
  title,
  id,
  isComplete,
  isStarted,
  isOptional,
  jobId
}) => {
  const navigate = useNavigate();
  const startAssessemntHandler = () => {
    APICaller(`/application/assessments/${id}/start`, MethodType.POST)
      .then(res => {
        console.log(res);
        if (!res.errorMessage) {
          navigate(`/job/${jobId}/assessment/${id}`);
        }
      })
      .catch(e => {
        console.log(e);
      });
  };
  return (
    <Card
      sx={{ mb: 4, width: '100%', padding: '10px 15px' }}
      className="assessment-card"
    >
      <Grid container direction="row" alignItems="center" justifyItems="center">
        <Grid container xs={8} md={8} item direction="row">
          <Grid item>
            <Typography
              variant="h6"
              sx={{ textAlign: 'left', fontWeight: 'bold' }}
            >
              {title}
            </Typography>
          </Grid>
          {isOptional ? (
            <Grid item sx={{ ml: 2, mt: '4px' }}>
              <Chip size="small" label="Optional" color="default" />
            </Grid>
          ) : null}
        </Grid>
        <Grid item container xs={4} md={4} justifyContent="flex-end">
          {isComplete ? (
            <Button
              className="viewDetailsButton"
              variant="contained"
              sx={{
                backgroundColor: 'var(--ttg-green)',
                '&:hover': {
                  backgroundColor: 'var(--ttg-green)',
                },
                marginTop: '20px',
                padding: '10px 20px',
                cursor: 'default',
              }}
            >
              {'Assessment Completed'}
            </Button>
          ) : isStarted ? (
            <NavLink to={`/job/${jobId}/assessment/${id}`}>
              <Button
                className="viewDetailsButton"
                variant="contained"
                sx={{
                  backgroundColor: 'var(--ttg-black)',
                  '&:hover': {
                    backgroundColor: 'var(--ttg-green)',
                  },
                  marginTop: '20px',
                  padding: '10px 20px',
                }}
              >
                {'Continue Assessment'}
              </Button>
            </NavLink>
          ) : (
            <Button
              className="viewDetailsButton"
              variant="contained"
              sx={{
                backgroundColor: 'var(--ttg-black)',
                '&:hover': {
                  backgroundColor: 'var(--ttg-green)',
                },
                marginTop: '20px',
                padding: '10px 20px',
              }}
              onClick={startAssessemntHandler}
            >
              {'Start Assessment'}
            </Button>
          )}
        </Grid>
      </Grid>
    </Card>
  );
};

export default AssessmentCard;
export { AssessmentCardProps };
